import type { FC, ReactNode } from 'react';
import styles from '../styles/grey-bordered-box.module.scss';

const GreyBorderedBox: FC<{
    className?: string;
    children: ReactNode;
}> = ({ className = '', children }) => {
    return <div className={`${styles.greyBox} ${className}`}>{children}</div>;
};

export default GreyBorderedBox;
